export const areaToRadius = (area: number, divide: number) => {
    const radius: number = Math.sqrt(area * divide / Math.PI)
    return radius
}